/***
 * 玩法相关赔率提取
 */

/***
 * 逻辑分组
 * @param odds
 * @param tabs
 * @param curInnerTab 连码二级选择
 * @returns {Array}
 */

export const computedData = (odds, current, curInnerTab) => {

  const list = {
    vertical: [],
    horizontal: []
  };

  // 两面盘
  if (current && current.sub_category_id === 1) {
    const data = {};
    odds.forEach(item => {
      if (!data[item.class2]) data[item.class2] = [];
      data[item.class2].push({
        ...item,
        selected: false,
        rate: item.odds,
        label: item.class3
      });
    });

    Object.keys(data).forEach(title => {
      const item = {
        title,
        list: data[title]
      };
      list[title === '总和' ? 'horizontal' : 'vertical'].push(item);
    });
    // 单号1-8
  } else if (current && current.sub_category_id === 2) {
    const data = {};
    odds.forEach(item => {
      if (!data[item.class3]) data[item.class3] = [];
      data[item.class3].push({
        ...item,
        selected: false,
        rate: item.odds,
        label: item.class3
      });
    });

    Object.keys(data).forEach(title => {
      const item = {
        title: data[title][0].class3,
        list: data[title]
      };
      list.vertical.push(item);
    });

    // 正码总和
  } else if (current && current.sub_category_id === 11) {
    const data = {};
    odds.forEach(item => {
      if (!data[item.class2]) data[item.class2] = [];
      data[item.class2].push({
        ...item,
        selected: false,
        rate: item.odds,
        label: item.class3
      });
    });

    Object.keys(data).forEach(title => {
      list.horizontal.push({
        title,
        list: data[title]
      });
    });

    // 连码
  } else if (current && current.sub_category_id === 12) {

    const item = odds.find(item => item.id === curInnerTab);

    let name = '';

    if (item) name = item.played_name;

    /***
     * 这里要看看
     * 连码数据怎么返回
     */

    list.horizontal.push({
      title: name,
      list: new Array(20).fill({
        label: 1,
        value: 1,
        ...item
      }).map((item, index) => ({
        ...item,
        selected: false,
        label: index + 1,
        odds_tpl_id: index + 1,
        lm: true
      }))
    });

    // 第几球
  } else if (current) {
    list.horizontal.push({
      title: current.label,
      list: []
    });
    list.horizontal.push({
      title: current.label,
      list: []
    });
    list.horizontal.push({
      title: '方位',
      list: []
    });

    let index;
    odds.forEach(item => {
      // 第N球
      if (item.class1 === current.label) {
        index = 0;
      } else if (item.class1 === '两面') {
        index = 1;
      } else {
        index = 2;
      }

      list.horizontal[index].list.push({
        ...item,
        selected: false,
        rate: item.odds,
        label: item.class3
      });
    });
  }

  return list;
};


/***
 * pk10 系列玩法UI展示数据优化
 */
export const computedDataPK10 = (odds, current) => {

  const list = {
    vertical: [],
    horizontal: []
  };

  if (!current) return list;

  const data = {};

  switch (current.sub_category_id) {
    case 1:
      const x_key = '冠、亚军和';
      const x_data = [];

      odds.forEach(item => {

        if (
          item.played_name &&
          item.played_name.indexOf('冠亚') >= 0
        ) {
          if (!x_data[x_key]) x_data[x_key] = [];
          x_data[x_key].push({
            ...item,
            selected: false,
            rate: item.odds
          });
          return;
        }

        if (!data[item.class2]) data[item.class2] = [];
        data[item.class2].push({
          ...item,
          selected: false,
          rate: item.odds
        });
      });

      Object.keys(data).forEach(title => {
        if (data[title] instanceof Array) data[title] = data[title].map(item => ({
          ...item,
          label: item.class3
        }));

        const item = {
          title: data[title][0].class2,
          list: data[title]
        };
        list.vertical.push(item);
      });


      Object.keys(x_data).forEach(title => {
        if (x_data[title] instanceof Array) x_data[title] = x_data[title].map(item => ({
          ...item,
          label: item.class3
        }));

        const item = {
          title: x_data[title][0].class2,
          list: x_data[title]
        };
        list.horizontal.push(item);
      });


      break;
    case 2:
      odds.forEach(item => {
        if (!data[item.class1]) data[item.class1] = [];
        data[item.class1].push({
          ...item,
          selected: false,
          rate: item.odds
        });
      });

      Object.keys(data).forEach(title => {

        if (data[title] instanceof Array) data[title] = data[title].map(item => ({
          ...item,
          label: item.class3
        }));

        const item = {
          title: data[title][0].class1,
          list: data[title]
        };
        list.vertical.push(item);
      });
      break;
    case 3:
      const index_name = '冠亚和';
      const arr = [];

      odds.forEach(item => {
        if (item.played_name.indexOf(index_name) >= 0) {
          arr.push({
            ...item,
            rate: item.odds,
            label: item.class3
          })
        } else if (item.played_name.indexOf('冠亚') >= 0) {
          arr.unshift({
            ...item,
            rate: item.odds,
            label: item.class3
          });
        }
      });

      list.horizontal.push({
        title: '冠亚和',
        list: arr
      });
      break;
  }

  return list;
};


/***
 * 时时彩系列处理
 */
// export const computedDataSsc = (odds, current) => {
//
//   const list = {
//     vertical: [],
//     horizontal: []
//   };
//
//   if (!current) return;
//
//   list.horizontal.push({
//     title: current.label,
//     list: []
//   });
//   list.horizontal.push({
//     title: current.label,
//     list: []
//   });
//   list.horizontal.push({
//     title: '方位',
//     list: []
//   });
//
//   let index;
//
//   odds.forEach(item => {
//
//     // 第N球
//     if (item.class1 === current.label) {
//       index = 0;
//     } else if (item.class1 === '两面') {
//       index = 1;
//     } else {
//       index = 2;
//     }
//     list.horizontal[index].title = item.class1;
//     list.horizontal[index].list.push({
//       ...item,
//       selected: false,
//       rate: item.odds,
//       label: item.class3
//     });
//   });
//
//   for (let i = 0; i < list.horizontal.length; i++) {
//     if (!list.horizontal[i].list.length) {
//       list.horizontal.splice(i, 1);
//       i--;
//     }
//   }
//
//   return list;
// };

export const computedDataSsc = (odds, current) => {

  const list = {
    vertical: [],
    horizontal: []
  };

  if (!current) return list;

  const key = 'class2';
  const isZh = current.value == 1;

  const index = {
    vertical: {},
    horizontal: {}
  };

  odds.forEach(item => {

    const zh = item[key].indexOf('第') < 0 ? 'horizontal' : 'vertical';
    const dir = isZh ? zh : 'horizontal';

    if (index[dir][item[key]] === undefined) {
      list[dir].push({
        title: item[key],
        list: []
      });
      index[dir][item[key]] = list[dir].length - 1;
    }

    const i = index[dir][item[key]];

    list[dir][i].list.push({
      ...item,
      selected: false,
      rate: item.odds,
      label: item.class3
    });

  });

  return list;
};

/***
 * 补充投注的连码数据
 * 根据选号规则计算
 */
export const computedLm = (orders, info) => {
  const class3List = [];
  orders.map((item, index) => {
    class3List.push(item.label)
  });
  const funs = {
    '任选二': list => combine(list, 2),
    '选二连直': list => combine(list, 2),
    '选二连组': list => combine(list, 2),
    '任选三': list => combine(list, 3),
    '选三前组': list => combine(list, 3),
    '任选四': list => combine(list, 4),
    '任选五': list => combine(list, 5)
  };

  const key = info.played_name.trim();

  const res = funs[key] ? funs[key](orders.map(item => item.label)).map(item => {
    return {
      ...info,
      class4: item.join(','),
      class3: class3List.join(','),
      value: orders.length ? orders[0].value : NaN,
      id: orders.length ? orders[0].id : NaN
    };
  }) : [];

  return res;
};

export const computedDataFt = (odds, current) => {

  const list = {
    vertical: [],
    horizontal: []
  };

  list.horizontal.push({
    title: '行1',
    list: []
  });
  list.horizontal.push({
    title: '4念3',
    list: []
  });
  list.horizontal.push({
    title: '4念2',
    list: []
  });
  list.horizontal.push({
    title: '2念3',
    list: []
  });
  list.horizontal.push({
    title: '4念1',
    list: []
  });
  list.horizontal.push({
    title: '行5',
    list: []
  });
  list.horizontal.push({
    title: '正',
    list: []
  });
  list.horizontal.push({
    title: '三门',
    list: []
  });
  list.horizontal.push({
    title: '一通',
    list: []
  });
  list.horizontal.push({
    title: '二通',
    list: []
  });
  list.horizontal.push({
    title: '三通',
    list: []
  });
  list.horizontal.push({
    title: '四通',
    list: []
  });
  list.horizontal.push({
    title: '1番',
    list: []
  });
  list.horizontal.push({
    title: '2番',
    list: []
  });
  list.horizontal.push({
    title: '3番',
    list: []
  });
  list.horizontal.push({
    title: '4番',
    list: []
  });
  list.horizontal.push({
    title: '单',
    list: []
  });
  list.horizontal.push({
    title: '双',
    list: []
  });
  list.horizontal.push({
    title: '方位',
    list: []
  });

  let index;
  odds.forEach(item => {
    if ((item.class1 === '角' && (item.class3=='3 4' || item.class3=='2 3')) || (item.class1 === '念' && (item.class3=='3念1' || item.class3=='3念2' || item.class3=='3念4'))) {
      index = 0;
    } else if (item.class1 === '念' && item.class3=='4念3') {
      index = 1;
    } else if (item.class1 === '念' && (item.class3=='4念2'||item.class3=='2念4')) {
      index = 2;
    } else if (item.class1 === '念' && item.class3=='2念3') {
      index = 3;
    } else if (item.class1 === '念' && (item.class3=='4念1'||item.class3=='2念1')) {
      index = 4;
    } else if ((item.class1 === '角' && (item.class3=='4 1' || item.class3=='1 2')) || (item.class1 === '念' && (item.class3=='1念4' || item.class3=='1念3' || item.class3=='1念2'))) {
      index = 5;
    } else if (item.class1 === '正') {
      index = 6;
    } else if (item.class1 === '三门') {
      index = 7;
    } else if (item.class2 === '一通') {
      index = 8;
    } else if (item.class2 === '二通') {
      index = 9;
    } else if (item.class2 === '三通') {
      index = 10;
    } else if (item.class2 === '四通') {
      index = 11;
    } else if (item.class1 === '番' && item.class3 === '1') {
      index = 12;
    } else if (item.class1 === '番' && item.class3 === '2') {
      index = 13;
    } else if (item.class1 === '番' && item.class3 === '3') {
      index = 14;
    } else if (item.class1 === '番' && item.class3 === '4') {
      index = 15;
    } else if (item.class1 === '单双' && item.class3 === '单') {
      index = 16;
    } else if (item.class1 === '单双' && item.class3 === '双') {
      index = 17;
    }else {
      index = 18;
    }

    list.horizontal[index].list.push({
      ...item,
      selected: false,
      rate: item.odds,
      label: item.class3
    });
  });
  list.horizontal[0].list.sort(function(a,b){
    // order是规则  objs是需要排序的数组
    var order = ["3 4", "3念4", "3念1", "3念2", "2 3"];
    return order.indexOf(a.class3) - order.indexOf(b.class3);
  });
  list.horizontal[2].list.sort(function(a,b){
    // order是规则  objs是需要排序的数组
    var order = ["4念2", "2念4"];
    return order.indexOf(a.class3) - order.indexOf(b.class3);
  });
  list.horizontal[4].list.sort(function(a,b){
    // order是规则  objs是需要排序的数组
    var order = ["4念1", "2念1"];
    return order.indexOf(a.class3) - order.indexOf(b.class3);
  });
  list.horizontal[5].list.sort(function(a,b){
    // order是规则  objs是需要排序的数组
    var order = ["1 4", "1念4", "1念3", "1念2", "1 2"];
    return order.indexOf(a.class3) - order.indexOf(b.class3);
  });
  return list;
};

function combine(arr, num) {
  const r = [];
  (function f(t, a, n) {
    if (n == 0) {
      return r.push(t);
    }
    for (let i = 0, l = a.length; i <= l - n; i++) {
      f(t.concat(a[i]), a.slice(i + 1), n - 1);
    }
  })([], arr, num);
  return r;
}


export const createHistoryKey = data => data.category_id.toString() + data.lottery_type.toString() + data.sub_category_id.toString();



// WEBPACK FOOTER //
// ./src/utils/computed.js